import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import moment from "moment";
import { BackImgContainer } from "../../components/Containers";
import { CustomerHistory } from "../../models";
import { CustomerService, OrderService } from "../../services";
import { AiFillCaretUp, AiFillCaretDown, AiOutlineLine } from "react-icons/ai";
import { GridFactory, IColumn } from "../../components/Grid";
import { OperationType } from "../../shared/Constants";
import { JumpBtn } from "../../components/Buttons";
import { useWindowDimension } from "../../shared/utils/CustomHooks";
import MobileView from "./MobileView";
import Modal from "../../components/Modal";

const parseDate = (date?: Date) => {
    return date ? moment(date).format("DD/MM/YY HH:mm") : "";
};

const amountData = (item: CustomerHistory) => {
    switch (
        item.balanceOperationTypeCode &&
        item.balanceOperationTypeCode.toUpperCase()
    ) {
        case OperationType.ADD:
            return {
                value: `+${item.amount}`,
                Icon: (
                    <AiFillCaretUp
                        style={{ color: "green", marginRight: "1vw" }}
                    />
                ),
            };
        case OperationType.SUBTRACT:
            return {
                value: `-${item.amount}`,
                Icon: (
                    <AiFillCaretDown
                        style={{ color: "red", marginRight: "1vw" }}
                    />
                ),
            };
        default:
            return {
                value: `${item.amount}`,
                Icon: (
                    <AiOutlineLine
                        style={{ color: "grey", marginRight: "1vw" }}
                    />
                ),
            };
    }
};

const renderAmount = (item: CustomerHistory) => {
    const data = amountData(item);
    return (
        <span>
            {data.Icon}
            {data.value}
        </span>
    );
};

const historyColumns = (cancelOrder: Function): IColumn<CustomerHistory>[] => [
    {
        label: "Operación",
        fieldKey: "balanceEventTypeDescription",
    },
    {
        label: "Fecha",
        fieldKey: "createdDate",
        renderItem: (item) => <span>{parseDate(item.createdDate)}</span>,
    },
    {
        label: "Créditos",
        fieldKey: "amount",
        renderItem: renderAmount,
    },
    {
        label: "Menú",
        fieldKey: "orderMenuDescription",
    },
    {
        label: "Tipo de Menú",
        fieldKey: "orderMenuTypeDescription",
    },
    {
        label: "Estado del Pedido",
        fieldKey: "orderStatusTypeDescription",
        renderItem: (item) => (
            <span>
                {item.orderStatusTypeDescription} -{" "}
                {parseDate(item.orderEditedDate)}
            </span>
        ),
    },
    {
        label: "Envío a Piso",
        fieldKey: "orderIsDelivery",
        renderItem: (item) => (
            !item.orderIsDelivery ? 'No' : `Si - ${item.orderDeliveryMessage}`
        ),
    },
    {
        label: "Acciones",
        fieldKey: "",
        renderItem: (item) => {
            if (
                item.orderStatusTypeCode &&
                item.orderStatusTypeCode.toUpperCase() === "PENDING"
            )
                return (
                    <JumpBtn
                        borderColor={"#ef3c34"}
                        colorOnHover={"#ef3c34"}
                        value="Cancelar"
                        onClick={() => cancelOrder(item.orderID)}
                    />
                );

            return null;
        },
    },
];

const cancelOrder = async (id: number) => {
    const sr = await OrderService.CancelOrder(id);
    if (sr.status()) {
        toast.success("Pedido cancelado!");
    } else {
        toast.error(sr.getParsedError());
        return false;
    }
    return true;
};

const Grid = GridFactory<CustomerHistory>();

const DesktopView: React.FC = () => {
    const [forceFetch, setforceFetch] = useState<boolean>(false);

    const [openModal, setOpenModal] = useState(false);
    const [orderId, setOrderId] = useState<number>();

    useEffect(() => {}, []);

    const getModal = () => {
        const clearModal = () => {
            setOpenModal(!openModal);
            setOrderId(undefined);
        };

        const groupButtons = () => {
            return (
                <>
                    <JumpBtn
                        key={1}
                        borderColor={"#0053a0"}
                        colorOnHover={"#0053a0"}
                        value="Si"
                        onClick={async () => {
                            if (await cancelOrder(orderId!)) {
                                setforceFetch((prev) => !prev);
                            }
                            clearModal();
                        }}
                        style={{
                            padding: "5px 1.6em 0.65em",
                        }}
                    />
                    <JumpBtn
                        key={2}
                        borderColor={"#ef3c34"}
                        colorOnHover={"#ef3c34"}
                        value="No"
                        onClick={() => clearModal()}
                    />
                </>
            );
        };
        return (
            <>
                <Modal
                    title={"Confirma que desea cancelar su pedido?"}
                    active={openModal}
                    hideModal={() => clearModal()}
                    children={groupButtons()}
                />
            </>
        );
    };

    const cancel = async (id: number) => {
        setOrderId(id);
        setOpenModal(!openModal);
    };

    return (
        <BackImgContainer>
            {getModal()}
            <Grid
                columns={historyColumns(cancel)}
                service={CustomerService.GetHistory}
                forceRefresh={forceFetch}
            />
        </BackImgContainer>
    );
};

const HistoryPage: React.FC = () => {
    const dimensions = useWindowDimension();

    return dimensions.width < 1224 ? (
        <MobileView amountData={amountData} cancelOrder={cancelOrder} />
    ) : (
        <DesktopView />
    );
};

export default HistoryPage;
